import React, { useCallback, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { makeStyles } from "@material-ui/core/styles";

import Loading from "../../../../common/Loading";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

import Button from "components/CustomButtons/Button";

const validationSchema = Yup.object().shape({
  countVotingNumber: Yup.number()
    .min(0, "Min value 0.")
    .required("Number of Voting Board Members is required")
});

const useStyles = makeStyles(theme => ({
  dialogActions: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2)
  },
  marginBottom: {
    marginBottom: theme.spacing(3)
  },
  marginRight: {
    marginRight: theme.spacing(3)
  }
}));

const VotingDialog = ({ open, data, year, onClose, onSave }) => {
  const classes = useStyles();

  const [isDirty, setDirty] = useState(false);

  const handleSubmit = useCallback(values => {
    setDirty(true);
    onSave(values.countVotingNumber);
  }, []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Chapter Financial Information</DialogTitle>
      <DialogContent>
        <Grid container direction="column">
          <Typography className={classes.marginBottom}>
            <strong>Chapter Board Voting Information</strong>
          </Typography>
          <Typography className={classes.marginBottom}>
            Please provide the number of voting board members that were in your
            chapter at the end of the fiscal year (September 20, {year})? .
          </Typography>
          <Formik
            initialValues={{
              countVotingNumber: data
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              isValid
            }) => (
              <Form autoComplete="off">
                <Grid item>
                  <Grid container direction="column" spacing={2}>
                    <TextField
                      className={classes.marginBottom}
                      error={Boolean(
                        touched.countVotingNumber && errors.countVotingNumber
                      )}
                      helperText={
                        touched.countVotingNumber &&
                        errors.countVotingNumber &&
                        "Enter a valid number"
                      }
                      fullWidth
                      label="Number of Voting Board Members:"
                      variant="outlined"
                      name="countVotingNumber"
                      value={values.countVotingNumber}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <div className={classes.dialogActions}>
                  {isDirty ? (
                    <Loading />
                  ) : (
                    <>
                      <Button
                        className={classes.marginRight}
                        color="success"
                        variant="contained"
                        type="submit"
                      >
                        Submit
                      </Button>
                      <Button
                        color="danger"
                        variant="contained"
                        onClick={onClose}
                      >
                        Cancel
                      </Button>
                    </>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default VotingDialog;
